module.exports = __webpack_public_path__ + "img/13_36.c3cc0b4d.png";